import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { getCurrencySymbol, isNegative, getPositiveSum } from '../../../../helpers';
import numeral from 'numeral';
import moment from 'moment';

import PaymentBadge from './../common/PaymentBadge';

const Wrapper = styled('tr')`
  .link-small {
    font-size: 12px;
    color: #323a46;
  }
  strong {
    display: block;
    color: #323a46;
    font-size: 14px;
  }

  .neg {
    color: #f1556c;
  }

  td {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .pos {
    color: #1aae67;
  }
  .hide {
    display: none;
  }
  .docs-list {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
  }
  .title {
    display: block;
    color: #323a46;
    font-size: 14px;
  }
  .docs-title {
    cursor: pointer;
    font-size: 14px;
    .fe-chevron-down,
    .fe-chevron-up {
      margin-left: 10px;
      display: inline-block;
    }
  }
`;

const TableRow = (props) => {
  const { item, urlSearchStr, t = null } = props;
  const [toogleList, setToogleList] = useState({});

  const handleToogleList = (item) => {
    !toogleList.hasOwnProperty(item)
      ? setToogleList({
          ...toogleList,
          [item]: true,
        })
      : setToogleList({
          ...toogleList,
          [item]: !toogleList[item],
        });
  };

  return (
    <>
      <Wrapper>
        <td>
          <span className="text-muted">{moment(item.date).format('DD.MM.YYYY')}</span>
        </td>
        <td>
          {!item.relations?.length ? (
            item.items?.length ? (
              <Link className="" to={{ pathname: `/finances/${item.id}` }}>
                <span className="title">{item.title}</span>
                {item.description && (
                  <span className="text-muted">{t ? t(item.description) : item.description}</span>
                )}
              </Link>
            ) : (
              <>
                <span className="title">{item.title}</span>
                {item.description && (
                  <span className="text-muted">{t ? t(item.description) : item.description}</span>
                )}
              </>
            )
          ) : (
            <>
              <span className="docs-title" onClick={() => handleToogleList(item.id)}>
                {item.title}
                {toogleList[item.id] ? (
                  <span className="fe-chevron-up"></span>
                ) : (
                  <span className="fe-chevron-down"></span>
                )}
              </span>
              <ul className={!toogleList[item.id] ? 'hide' : null + ' docs-list'}>
                {item.relations.map((d) => (
                  <li>
                    <Link
                      className="link-small"
                      to={{
                        pathname: `/finances/${d.id}`,
                        state: {
                          customBackLink: urlSearchStr ? '/finances' + urlSearchStr : null,
                        },
                      }}
                    >
                      <span>
                        {d.title} от {moment(d.date).format('DD.MM.YYYY')} {t('на сумму')}{' '}
                        <span className="font-weight-bolder">{`${numeral(d.relationSum).format(
                          '0,0.00',
                        )} ${getCurrencySymbol('RUB')}`}</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </td>
        <td align="right">
          {item.type === 'REPORT' && (
            <strong>
              {`${numeral(item.totalSum).format('0,0.00')} ${getCurrencySymbol('RUB')}`}
            </strong>
          )}
        </td>
        <td align="right">
          {item.type === 'PAYMENT' && (
            <strong className="pos">
              {`+${numeral(item.totalSum).format('0,0.00')} ${getCurrencySymbol('RUB')}`}
            </strong>
          )}
          {item.type === 'EXPENSE' && (
            <strong className="neg">
              {`-${numeral(item.totalSum).format('0,0.00')} ${getCurrencySymbol('RUB')}`}
            </strong>
          )}
        </td>
        <td></td>
      </Wrapper>
    </>
  );
};

export default TableRow;
